<template>
    <div class="record-requests">
        <div class="header">
            <common-icon name="timer" size="medium" class="icon"></common-icon>
            <h5 class="main-title">{{ $t('modals.patient_profile.profile.record_form.head') }}</h5>
        </div>

        <div>
            <template v-if="patientRecordRequests && patientRecordRequests.length > 0">
                <div v-for="request in patientRecordRequests" :key="request.id" class="request-card">
                    <div class="main">
                        <div class="card-headers">
                            <h3 class="hospital">{{ request.toProviderName }}</h3>
                            <span :class="['status', request.status.toLowerCase()]">
                                <common-icon :name="getIcon(request.status)" size="tiny"></common-icon>
                                {{ formatStatus(request.status) }}
                            </span>
                            <span v-if="!request.emailRequest" class="network">
                                {{ $t('modals.patient_profile.profile.request.record_request.network') }}
                            </span>

                            <span v-if="request.emailRequest" class="email">
                                {{ $t('modals.patient_profile.profile.request.record_request.emails') }}
                            </span>
                        </div>

                        <div class="actions">
                            <button class="btn detail" @click="OpenModel(request)">
                                <common-icon name="view" size="tiny"></common-icon>
                                {{ $t('modals.patient_profile.profile.record_form.button.title') }}
                            </button>
                            <button v-if="request.download" class="btn download">
                                <common-icon name="download" size="tiny"></common-icon>
                                {{ $t('modals.patient_profile.profile.record_form.button.downloadtitle') }}
                            </button>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="card_grid">
                            <p>
                                <strong>{{ $t('modals.patient_profile.profile.record_form.request_id.id') }}</strong>
                                {{ $t('modals.patient_profile.profile.request.record_request.req') }}{{ request.id }}
                            </p>
                            <p>
                                <strong>{{ $t('modals.patient_profile.profile.record_form.request_id.date') }}</strong>
                                {{ dateFormate(request.createdDateTime) }}
                            </p>
                            <p v-if="request.expected">
                                <strong>{{ $t('modals.patient_profile.profile.record_form.request_id.expected') }}</strong>
                                {{ request.expected }}
                            </p>
                        </div>

                        <p>
                            <strong>{{ $t('modals.patient_profile.profile.record_form.record.name') }}</strong>
                            {{ request.recordTypes?.join(', ') }}
                        </p>
                        <p>
                            <strong>{{ $t('modals.patient_profile.profile.record_form.notes.name') }}</strong>

                            {{ request.notes }}
                        </p>
                    </div>
                </div>
            </template>
            <div v-else class="request-card">
                <span>{{ $t('modals.patient_profile.profile.request.no_record_request_found') }}</span>
            </div>
        </div>

        <details-model
            :request="selectedRequest"
            :availHipaaForms="availHipaaForms"
            :isOpen="isDetailsModelOpen"
            @close="closeModal()"
        ></details-model>
    </div>
</template>

<script>
    import DetailsModel from 'components/page-elements/patient/DetailsModel'
    import { dateFormate } from '~/helpers'

    export default {
        components: { DetailsModel },

        props: {
            patientRecordRequests: { type: Array, required: true },
            availHipaaForms: { type: Array, required: true },
        },
        data() {
            return {
                isDetailsModelOpen: false,
                selectedRequest: {},
            }
        },
        methods: {
            dateFormate,
            OpenModel(request) {
                this.selectedRequest = request
                this.isDetailsModelOpen = true
            },
            closeModal() {
                this.selectedRequest = {}
                this.isDetailsModelOpen = false
            },
            getIcon(status) {
                const map = {
                    PENDING: 'timer',
                    APPROVED: 'check-circle',
                    REJECTED: 'close',
                    RECEIVED: 'download',
                }
                return map[status?.toUpperCase()] || 'info'
            },
            formatStatus(status) {
                if (!status) return ''
                return status.toLowerCase().replace(/(?:^|\s|-|_)\w/g, (match) => match.toUpperCase())
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .record-requests {
        padding: 20px 28px;
        border-radius: 12px;
        border: 1px solid #ddd;
        background-color: #fff;
    }
    .header {
        display: flex;
        margin-bottom: 20px;
        gap: 10px;
        .icon {
            color: #000000;
        }
    }
    .main-title {
        font-size: 16px;
        font-weight: 400;
        color: #000000;
    }
    .request-card {
        border: 1px solid #0000001a;
        border-radius: 8.75px;
        padding: 14px;
        margin-bottom: 16px;
        background: #fff;
        transition: background-color 0.2s ease, border-color 0.2s ease;
    }
    .request-card:hover {
        background-color: #f9fafb;
    }
    .main {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }
    .card-headers {
        display: flex;
        align-items: center;
        gap: 10.5px;
    }
    .hospital {
        font-size: 15px;
        font-weight: 500;
        white-space: nowrap;
        color: #0a0a0a;
    }
    .status {
        padding: 1.75px 7px;
        border-radius: 6.75px;
        font-size: 10.5px;
        font-weight: 500;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 3.5px;
        line-height: 1.4;
    }
    .status.pending {
        background: #fef9c2;
        color: #894b00;

        i {
            color: #894b00;
        }
    }
    .status.received {
        background: #dbeafe;
        color: #193cb8;
        i {
            color: #193cb8;
        }
    }
    .status.approved {
        background: #dcfce7;
        color: #016630;

        i {
            color: #016630;
        }
    }
    .status.rejected {
        background: #ffe2e2;
        color: #9f0712;

        i {
            color: #9f0712;
        }
    }
    .network {
        border: 1px solid #00a63e;
        color: #00a63e;
        font-size: 10.5px;
        padding: 1.75px 7px;
        font-weight: 500;
        border-radius: 6.75px;
        background: #fff;
        line-height: 1.4;
    }
    .email {
        color: #155dfc;
        font-size: 10.5px;
        padding: 1.75px 7px;
        font-weight: 500;
        border: 1px solid #155dfc;
        border-radius: 6.75px;
        background: #fff;
        line-height: 1.4;
    }
    .actions {
        display: flex;
        gap: 7px;
        margin-left: 14px;
    }
    .btn {
        border: 1px solid #e5e7eb;
        border-radius: 6.75px;
        padding-inline: 8.75px;
        cursor: pointer;
        font-size: 12.25px;
        font-weight: 500;
        display: inline-flex;
        justify-content: center;
        height: 28px;
        align-items: center;
        gap: 5.25px;
        background: #fff;
        transition: background-color 0.15s ease;

        &:hover {
            color: #0a0a0a;
            background-color: #f3f4f6;
        }
    }
    .btn.detail {
        color: #0a0a0a;
    }
    .btn.download {
        color: #155dfc;
    }
    .card-body {
        font-size: 14px;
        color: #4b5563;
    }
    .card_grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
    }
    .card-body p {
        margin: 4px 0;
        color: #4b5563;
        font-size: 14px;
    }
    .card-body p strong {
        color: #111827;
        font-size: 14px;
        font-weight: 500;
    }
    @media screen and (max-width: 600px) {
        .card-headers,
        .main {
            display: block !important;
        }
    }
</style>
